/* External */
import {
  useEffect, useMemo, useRef, useState,
} from 'react';
import { useDispatch, useSelector } from 'react-redux';

/* Storage */
import { getContinueWatchingShow } from '../storage/shows';
import { selectContentById } from '../storage/contents';

/* Utils */
import useRequestAndDelete from './useRequestAndDelete';
import { PROVIDERS, STATUS_TYPES } from '../utils/constants';

export default function useFetchContinueWatchingShow(showId, sourceProvider = PROVIDERS.VRIO) {
  const dispatch = useDispatch();
  const previousRequest = useRef();
  const [requestId, setRequestId] = useState(undefined);

  const request = useRequestAndDelete(requestId);

  useEffect(() => {
    if (showId) {
      const action = getContinueWatchingShow(`${showId}-${sourceProvider}`);
      setRequestId(action.requestId);

      dispatch(action);
    } else {
      setRequestId(undefined);
    }
  }, [dispatch, showId, sourceProvider]);

  if (!requestId) {
    previousRequest.current = undefined;
  } else if (request && (
    request.status === STATUS_TYPES.SUCCEED_STATE
    || request.status === STATUS_TYPES.FAILED_STATE
  )) {
    previousRequest.current = request;
  }

  const contentId = previousRequest.current?.result?.contents?.[0];
  const contentSelector = useMemo(() => selectContentById(contentId), [contentId]);
  const content = useSelector(contentSelector);

  return {
    contentId,
    content,
  };
}
